import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import toast from 'react-hot-toast'
import { Spinner } from '../../components/ui/Spinner'

export default function ForgotPasswordPage() {
  const { register, handleSubmit, formState: { isSubmitting, isSubmitSuccessful } } = useForm<{ email: string }>()

  async function onSubmit({ email }: { email: string }) {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })
    if (error) toast.error(error.message)
    else toast.success('Check your email for the reset link!')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-50 to-white px-4">
      <div className="w-full max-w-sm">
        <div className="card">
          <h1 className="text-xl font-bold text-gray-900 mb-1">Reset your password</h1>
          <p className="text-sm text-gray-500 mb-5">We'll send a reset link to your email.</p>

          {isSubmitSuccessful ? (
            <div className="rounded-xl bg-sage-50 border border-sage-200 p-4 text-sm text-sage-700">
              Reset link sent! Check your inbox (and spam folder).
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="label">Email address</label>
                <input type="email" className="input" placeholder="you@company.com" {...register('email', { required: true })} />
              </div>
              <button type="submit" disabled={isSubmitting} className="btn-primary w-full h-11">
                {isSubmitting ? <Spinner size="sm" /> : 'Send reset link'}
              </button>
            </form>
          )}

          <p className="text-center text-sm text-gray-500 mt-4">
            <Link to="/login" className="text-brand-600 hover:underline">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  )
}
